export  function formatNumber(number) {
    if (number){
        const formattedNumber = parseFloat(number).toFixed(2);
        const parts = formattedNumber.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    }
    return '0.00'
}

/** Formato de miles para inputs editables (ej. 1500000.5 -> 1.500.000,5). Guarda el valor crudo con parseNumberInput. */
export function formatNumberInput(value) {
    if (value === '' || value == null) return '';
    const str = String(value);
    const endsWithDecimal = /[.,]$/.test(str);
    const [integerPart, ...decimalParts] = str.replace(/\./g, ',').split(',');
    const digits = integerPart.replace(/\D/g, '');
    if (digits === '' && !endsWithDecimal) return '';
    const formattedInt = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const decimal = decimalParts.join('').replace(/\D/g, '');
    if (endsWithDecimal && decimal === '') return `${formattedInt},`;
    if (decimal !== '') return `${formattedInt},${decimal}`;
    return formattedInt;
}

/** Convierte valor con puntos de miles / coma decimal a número parseable (ej. 1.500.000,5 -> 1500000.5). */
export function parseNumberInput(value) {
    if (value === '' || value == null) return '';
    let cleaned = String(value).replace(/\./g, '').replace(',', '.');
    cleaned = cleaned.replace(/[^\d.]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) {
        cleaned = `${parts[0]}.${parts.slice(1).join('')}`;
    }
    return cleaned;
}

export function calculateDV(nit) {
    nit = nit.replace(/\s|,|\.|-/g, ""); 
    if (isNaN(nit)) return "";
    
    const vpri = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
    let sum = 0;
    for (let i = 0; i < nit.length; i++) {
      const digitNit = parseInt(nit[i]);
      sum += digitNit * vpri[nit.length - i - 1];
    }
    const mod = sum % 11;
    return `${ mod > 1 ? 11 - mod : mod}`;
}